/**
 * Skip Link Focus Fix
 * Ensures skip link properly moves keyboard focus to main content
 */
( function() {
	const skipLink = document.querySelector( '.skip-link' );
	
	if ( skipLink ) {
		skipLink.addEventListener( 'click', function( e ) {
			const targetId = this.getAttribute( 'href' ).substring( 1 );
			const target = document.getElementById( targetId );
			
			if ( target ) {
				e.preventDefault();
				
				// Ensure the target can receive focus
				if ( ! target.hasAttribute( 'tabindex' ) ) {
					target.setAttribute( 'tabindex', '-1' );
				}
				
				// Move focus to the target
				target.focus();
				
				// Scroll into view
				target.scrollIntoView( { behavior: 'smooth', block: 'start' } );
			}
		});
	}
}() );

/**
 * Accessibility Enhancements
 * Adds autocomplete attributes to form fields and improves ARIA labeling
 */
( function() {
	// Run accessibility enhancements
	function runAccessibilityEnhancements() {
		// Add autocomplete attributes to Forminator form fields
		enhanceFormAutocomplete();
		
		// Enhance archive card links with descriptive text
		enhanceCardLinks();
		
		// Fix radiogroup and checkbox group accessible names
		enhanceFormGroups();
		
		// Fix form accessible names (especially Mailchimp)
		enhanceFormAccessibility();
	}
	
	// Run on DOMContentLoaded
	document.addEventListener( 'DOMContentLoaded', runAccessibilityEnhancements );
	
	// Also run on window load (for dynamically enhanced forms like Forminator)
	window.addEventListener( 'load', function() {
		// Small delay to ensure all JS has finished
		setTimeout( runAccessibilityEnhancements, 100 );
	});
	
	function enhanceFormAutocomplete() {
		// Map common field names/IDs to autocomplete values
		const autocompleteMap = {
			// First name variations
			'first_name': 'given-name',
			'first-name': 'given-name',
			'firstname': 'given-name',
			'fname': 'given-name',
			'given-name': 'given-name',
			// Last name variations
			'last_name': 'family-name',
			'last-name': 'family-name',
			'lastname': 'family-name',
			'lname': 'family-name',
			'family-name': 'family-name',
			'surname': 'family-name',
			// Email variations
			'email': 'email',
			'email_address': 'email',
			'email-address': 'email',
			// Phone variations
			'phone': 'tel',
			'telephone': 'tel',
			'phone_number': 'tel',
			'phone-number': 'tel',
			'mobile': 'tel',
			'cell': 'tel',
			// Organization
			'organization': 'organization',
			'company': 'organization',
			'employer': 'organization',
			// Address
			'address': 'street-address',
			'street': 'street-address',
			'city': 'address-level2',
			'state': 'address-level1',
			'zip': 'postal-code',
			'zipcode': 'postal-code',
			'postal_code': 'postal-code',
			'country': 'country-name'
		};
		
		// Find all form inputs
		const inputs = document.querySelectorAll( 'input[type="text"], input[type="email"], input[type="tel"], input[type="search"]' );
		
		inputs.forEach( function( input ) {
			// Skip if already has autocomplete
			if ( input.hasAttribute( 'autocomplete' ) && input.getAttribute( 'autocomplete' ) !== 'off' ) {
				return;
			}
			
			// Check name, id, and label text for matches
			const name = ( input.name || '' ).toLowerCase().replace( /[\[\]_-]/g, '_' ).replace( /_+/g, '_' );
			const id = ( input.id || '' ).toLowerCase().replace( /[\[\]_-]/g, '_' ).replace( /_+/g, '_' );
			
			// Get associated label text
			let labelText = '';
			const label = document.querySelector( 'label[for="' + input.id + '"]' );
			if ( label ) {
				labelText = label.textContent.toLowerCase().trim();
			}
			
			// Check for matches
			for ( const key in autocompleteMap ) {
				if ( name.includes( key.replace( /-/g, '_' ) ) || 
				     id.includes( key.replace( /-/g, '_' ) ) || 
				     labelText.includes( key.replace( /-|_/g, ' ' ) ) ) {
					input.setAttribute( 'autocomplete', autocompleteMap[ key ] );
					break;
				}
			}
		});
	}
	
	function enhanceCardLinks() {
		// Find archive cards and add descriptive aria-labels
		const archiveCards = document.querySelectorAll( '.archive-card' );
		
		archiveCards.forEach( function( card ) {
			const overlayLink = card.querySelector( '.card-overlay-link' );
			const title = card.querySelector( '.card-title' );
			
			if ( overlayLink && title ) {
				const titleText = title.textContent.trim();
				overlayLink.setAttribute( 'aria-label', 'Read more about ' + titleText );
			}
		});
		
		// Also enhance upcoming events cards
		const eventCards = document.querySelectorAll( '.upcoming-events-card' );
		
		eventCards.forEach( function( card ) {
			const title = card.querySelector( '.upcoming-events-card-title' );
			
			if ( title && ! card.hasAttribute( 'aria-label' ) ) {
				const titleText = title.textContent.trim();
				card.setAttribute( 'aria-label', 'View event: ' + titleText );
			}
		});
	}
	
	function enhanceFormGroups() {
		// Fix Forminator radiogroups and checkbox groups with broken aria-labelledby references
		// Forminator generates aria-labelledby pointing to non-existent IDs
		
		// Find all elements with aria-labelledby and check if the referenced element exists
		const elementsWithLabelledby = document.querySelectorAll( '[aria-labelledby]' );
		
		elementsWithLabelledby.forEach( function( element ) {
			const labelledbyId = element.getAttribute( 'aria-labelledby' );
			const labelElement = document.getElementById( labelledbyId );
			
			// If the referenced element doesn't exist, the aria-labelledby is broken
			if ( ! labelElement ) {
				// Remove the broken reference
				element.removeAttribute( 'aria-labelledby' );
				
				// For Forminator, look for a label within the direct field container only
				const fieldContainer = element.closest( '.forminator-field-radio, .forminator-field-checkbox' );
				let foundLabel = false;
				
				if ( fieldContainer ) {
					// Look for a .forminator-label that's a direct child of the field container
					const directLabel = fieldContainer.querySelector( ':scope > .forminator-field > .forminator-label' ) ||
					                    fieldContainer.querySelector( ':scope > .forminator-label' );
					if ( directLabel ) {
						if ( ! directLabel.id ) {
							directLabel.id = 'group-label-' + Math.random().toString( 36 ).substr( 2, 9 );
						}
						element.setAttribute( 'aria-labelledby', directLabel.id );
						foundLabel = true;
					}
				}
				
				// Fallback: add descriptive aria-label based on content type
				if ( ! foundLabel ) {
					const role = element.getAttribute( 'role' );
					if ( role === 'radiogroup' ) {
						element.setAttribute( 'aria-label', 'Select an option' );
					} else if ( role === 'group' ) {
						const checkboxes = element.querySelectorAll( 'input[type="checkbox"]' );
						if ( checkboxes.length > 0 ) {
							element.setAttribute( 'aria-label', 'Select options' );
						}
					}
				}
			}
		});
		
		// Also handle radiogroups and groups that have NO aria-labelledby at all
		const unlabelledRadiogroups = document.querySelectorAll( '[role="radiogroup"]:not([aria-labelledby]):not([aria-label])' );
		
		unlabelledRadiogroups.forEach( function( group ) {
			// For Forminator, look for a label within the direct field container only
			const fieldContainer = group.closest( '.forminator-field-radio' );
			let foundLabel = false;
			
			if ( fieldContainer ) {
				const directLabel = fieldContainer.querySelector( ':scope > .forminator-field > .forminator-label' ) ||
				                    fieldContainer.querySelector( ':scope > .forminator-label' );
				if ( directLabel ) {
					if ( ! directLabel.id ) {
						directLabel.id = 'group-label-' + Math.random().toString( 36 ).substr( 2, 9 );
					}
					group.setAttribute( 'aria-labelledby', directLabel.id );
					foundLabel = true;
				}
			}
			
			if ( ! foundLabel ) {
				group.setAttribute( 'aria-label', 'Select an option' );
			}
		});
		
		const unlabelledGroups = document.querySelectorAll( '[role="group"]:not([aria-labelledby]):not([aria-label])' );
		
		unlabelledGroups.forEach( function( group ) {
			const checkboxes = group.querySelectorAll( 'input[type="checkbox"]' );
			if ( checkboxes.length === 0 ) return;
			
			// For Forminator, look for a label within the direct field container only
			const fieldContainer = group.closest( '.forminator-field-checkbox' );
			let foundLabel = false;
			
			if ( fieldContainer ) {
				const directLabel = fieldContainer.querySelector( ':scope > .forminator-field > .forminator-label' ) ||
				                    fieldContainer.querySelector( ':scope > .forminator-label' );
				if ( directLabel ) {
					if ( ! directLabel.id ) {
						directLabel.id = 'group-label-' + Math.random().toString( 36 ).substr( 2, 9 );
					}
					group.setAttribute( 'aria-labelledby', directLabel.id );
					foundLabel = true;
				}
			}
			
			if ( ! foundLabel ) {
				group.setAttribute( 'aria-label', 'Select options' );
			}
		});
	}
	
	function enhanceFormAccessibility() {
		// Fix Mailchimp honeypot fields that lack labels
		// These are hidden spam-prevention fields but still need labels for validation
		const honeypotFields = document.querySelectorAll( '.mc-bot-field input, .mc4wp-form input[tabindex="-1"]' );
		
		honeypotFields.forEach( function( input ) {
			if ( ! input.hasAttribute( 'aria-label' ) && ! input.hasAttribute( 'aria-labelledby' ) ) {
				// Add a descriptive label (field is already hidden from AT via parent aria-hidden)
				input.setAttribute( 'aria-label', 'Leave this field empty' );
			}
		});
		
		// Fix forms that lack accessible names
		const forms = document.querySelectorAll( 'form:not([aria-label]):not([aria-labelledby])' );
		
		forms.forEach( function( form ) {
			// Try to find a heading that describes this form
			const parent = form.closest( '.wp-block-group, .calie-newsletter, .newsletter-block, section, article' );
			
			if ( parent ) {
				// Look for a heading in the parent
				const heading = parent.querySelector( 'h1, h2, h3, h4, h5, h6' );
				if ( heading ) {
					// Use aria-labelledby to reference the heading
					if ( ! heading.id ) {
						heading.id = 'form-heading-' + Math.random().toString( 36 ).substr( 2, 9 );
					}
					form.setAttribute( 'aria-labelledby', heading.id );
					return;
				}
			}
			
			// Check for Mailchimp/newsletter specific forms
			if ( form.classList.contains( 'mc4wp-form' ) || 
			     form.closest( '.mc4wp-form-fields' ) ||
			     form.closest( '.calie-newsletter' ) ) {
				// Look for any nearby heading
				const container = form.closest( '.wp-block-group, .calie-newsletter, section' );
				if ( container ) {
					const heading = container.querySelector( 'h1, h2, h3, h4, h5, h6' );
					if ( heading ) {
						if ( ! heading.id ) {
							heading.id = 'newsletter-heading-' + Math.random().toString( 36 ).substr( 2, 9 );
						}
						form.setAttribute( 'aria-labelledby', heading.id );
						return;
					}
				}
				// Fallback: add a generic aria-label
				form.setAttribute( 'aria-label', 'Newsletter signup form' );
			}
			
			// Check for Forminator forms
			if ( form.classList.contains( 'forminator-ui' ) || form.classList.contains( 'forminator-custom-form' ) ) {
				// Try to find the form title
				const formTitle = form.querySelector( '.forminator-title, .forminator-form-title' );
				if ( formTitle ) {
					if ( ! formTitle.id ) {
						formTitle.id = 'forminator-title-' + Math.random().toString( 36 ).substr( 2, 9 );
					}
					form.setAttribute( 'aria-labelledby', formTitle.id );
					return;
				}
				
				// Look in parent container for heading
				const parentBlock = form.closest( '.wp-block-group, .entry-content > div, section' );
				if ( parentBlock ) {
					const heading = parentBlock.querySelector( 'h1, h2, h3, h4, h5, h6' );
					if ( heading && ! form.contains( heading ) ) {
						if ( ! heading.id ) {
							heading.id = 'form-section-heading-' + Math.random().toString( 36 ).substr( 2, 9 );
						}
						form.setAttribute( 'aria-labelledby', heading.id );
						return;
					}
				}
				
				// Fallback: use the form ID or a generic label
				const formId = form.getAttribute( 'data-form-id' ) || form.id;
				if ( formId ) {
					form.setAttribute( 'aria-label', 'Contact form' );
				}
			}
		});
	}
}() );

